<template>
  <div class="container">
    <div class="card" :class="{ flipped: isFlipped }" @click="flipCard">
      <div class="card-front">
        <v-row dense>
          <v-col cols="12" md="10">
            <v-img
              src="https://seeklogo.com/images/V/VISA-logo-62D5B26FE1-seeklogo.com.png"
              class="logo-card"
            />
          </v-col>

          <v-col cols="12" md="2">
            <v-img
              v-if="!data.current"
              contain
              src="@/assets/images/logo_pitch_white.png"
              height="1.5vh"
            />
            <v-icon v-else color="success-500">mdi-check-decagram</v-icon>
          </v-col>
        </v-row>
        <v-row style="margin-top: 6vh">
          <v-col class="d-flex flex-column" cols="12" md="9">
            <label>Número do cartão:</label>
            <input
              v-model="localItem.maskedNumber"
              :readonly="isReadonly"
              type="text"
              class="input cardnumber"
              :placeholder="data.maskedNumber"
              style="font-size: 1.5rem"
              :disabled="isReadonly"
            />
          </v-col>
          <v-col cols="12" md="3" class="d-flex align-center justify-center">
            <v-img
              contain
              src="@/assets/images/chip.webp"
              height="5vh"
              width="5vh"
              class="mt-4"
            />
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col class="d-flex flex-column" cols="12" md="9">
            <label>Nome:</label>
            <input
              v-model="localItem.holder"
              :readonly="isReadonly"
              class="input"
              :placeholder="data.holder"
              :disabled="isReadonly"
              style="text-overflow: ellipsis"
            />
          </v-col>
        </v-row>
      </div>
      <div class="card-back">
        <v-row dense>
          <v-img
            contain
            height="7vh"
            src="@/assets/images/logo_pitch_white.png"
          />
        </v-row>
        <v-row dense class="mt-4">
          <span class="white--text"
            >Para garantir maior segurança, seus dados ficarão armazenados junto
            a administradora de cartões</span
          >
        </v-row>
        <v-row dense class="mt-2">
          <v-col
            class="d-flex flex-column align-start justify-center"
            cols="12"
            md="6"
          >
            <label>Expires in:</label>
            <input
              v-model="localItem.exp"
              :readonly="isReadonly"
              class="input"
              :placeholder="`${data.expMonth}/${data.expYear}`"
              :disabled="isReadonly"
              style="text-overflow: ellipsis"
            />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardTemplate",
  components: {},
  props: {
    checkout: {
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      localItem: {},
      valid: false,
      isFlipped: false,
    };
  },
  watch: {
    data(value) {
      if (value) {
        this.localItem = value;
      }
    },
  },
  methods: {
    flipCard() {
      this.isFlipped = !this.isFlipped;
    },
  },
};
</script>

<style scoped>
.container {
  perspective: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  width: 60vh;
  height: 35vh;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.6s;
  cursor: pointer;
}

.card.flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 2px 10px 40px black;
}

.card-front {
  background: #16181a;
  z-index: 2;
  transform: rotateX(0deg);
}

.card-back {
  background: #1a1d21;
  transform: rotateY(180deg);
}

.logo-card {
  max-width: 50px;
  margin-bottom: 15px;
}

label {
  display: flex;
  font-size: 14px;
  color: white;
  opacity: 0.4;
}

input {
  font-family: "Work Sans", sans-serif;
  background: transparent;
  border: none;
  border-bottom: 1px solid transparent;
  color: #dbdce0;
  transition: border-bottom 0.4s;
  border-bottom: 1px solid #1abc9c;
}
input:focus {
  border-bottom: 1px solid #1abc9c;
  outline: none;
}

.cardnumber {
  font-size: 20px;
  margin-bottom: 8px;
}

.name {
  display: block;
  font-size: 20px;
  max-width: 50px;
  float: left;
  margin-bottom: 15px;
}

.ccv {
  width: 50px;
  font-size: 15px;
}
</style>
